<template>
  <div class="pages">
    <div class="page">
      <h3 style="text-align: center;">快问健康医生端隐私政策</h3>
      <p class="strong">【特别提示】</p>
      <b
        >请仔细阅读《快问健康医生端隐私政策》（尤其是粗体内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可通过《快问健康医生端隐私政策》中的联系方式咨询我们。</b
      >
      <li>版本：V5.15.7</li>
      <li>版本制定日期：2023年【8】月【21】日</li>
      <li>版本生效日期：2023年【8】月【21】日</li>
      <li>
        如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：
      </li>
      <li>
        联系电话：400-6898-820
      </li>
      <li>
        注册地址：广州市天河区东圃一横路23号2栋406室
      </li>

      <li class="marginT15">引言</li>
      <li>
        "我们"是广州快问中医门诊部有限公司，我们的服务由我们和其他多家运营实体关联公司或合作伙伴共同为您提供。我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《快问健康医生端隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
      </li>
      <li>本隐私政策将帮助您了解以下内容：</li>
      <li>一、定义与适用范围</li>
      <li>二、我们如何收集和使用您的个人信息</li>
      <li>三、我们如何使用Cookie和同类技术</li>
      <li>四、我们如何共享、转让、公开披露您的个人信息</li>
      <li>五、用户业务数据和公开信息</li>
      <li>六、我们如何保护您的个人信息</li>
      <li>七、您如何管理您的个人信息</li>
      <li>八、您的个人信息的储存</li>
      <li>九、我们如何处理未成年人的个人信息</li>
      <li>十、本声明和政策如何更新</li>
      <li>十一、如何联系我们</li>
      <li>十二、其他</li>
      <li class="marginT15 strong">
        本隐私政策与您所使用的快问健康医生端（服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。因为保护您的隐私对我们至关重要，我们会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，并恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请您再次仔细阅读本隐私政策，该政策解释我们如何收集、使用以及披露我们在服务中收到的信息。您使用服务即表示同意我们的《快问健康医生端隐私政策》，即同意我们按照本隐私政策收集、使用、处理和存储您的相关信息。如果您不同意本隐私政策，请您立即注销账户以终止使用我们的产品和服务。
      </li>
      <li class="marginT15">快问健康医生端隐私政策具体内容</li>
      <li class="strong">一、定义与适用范围</li>
      <li>
        <b>个人信息</b
        >是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<b>个人敏感信息</b>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息（我们将在本政策中对涉及到的个人敏感信息以<b>粗体</b>进行显著标识）。
      </li>
      <li>
        1.1本隐私政策中涉及的个人信息包括：<b>基本信息（包括个人姓名、生日、性别、住址、个人电话号码）；个人身份信息（包括身份证）；个人生物识别信息（包括声纹、面部识别特征）；网络身份标识信息（包括个人信息主体账号、IP地址、个人数字证书）；个人财产信息（包括交易和消费记录、优惠券）；通讯录；</b>个人上网记录（包括<b>网页浏览记录</b>、软件使用记录、点击记录）；<b
          >个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
          ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息））；个人位置信息（包括行程信息、精准定位信息、住宿信息、经纬度）；个人健康生理信息与健康医疗类信息</b
        >（包括<b
          >身高、体重、胸围、腰围、臀围、肺活量、血糖、血压、病症、门急诊病历记录、住院病历记录、用药记录、过敏信息、婚育信息、女性月经及妊娠哺乳信息、以往病史、诊治情况、家族病史、手术外伤史、输血史、血型、现病史、传染病史、体检记录）；生活习惯（吸烟习惯、饮酒习惯、饮食习惯、运动习惯、睡眠习惯及不良生活习惯）。其中，字体加粗部分为涉及的个人敏感信息。</b
        >
      </li>
      <p>
        1.2
        个人信息删除指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态
      </p>
      <p>
        1.3
        匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，不属于个人信息。
      </p>
      <p>
        1.4
        其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。
      </p>
      <p>
        1.5
        业务数据不同于个人信息，是指快问健康医生端的用户利用快问健康医生端的服务上传、下载、分发等通过快问健康医生端的技术服务处理的数据。
      </p>
      <p class="strong">
        二、我们如何收集和使用您的个人信息
      </p>
      <li class="strong">
        您须授权我们收集和使用您个人信息的情形我们的产品与/或服务包括一些核心功能，这些功能包含了实现健康服务所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：
      </li>
      <p>2.1 注册和登陆</p>
      <li>
        您需要向我们提供您的<span class="strong">手机号码</span
        >，并设置您的<span class="strong">用户密码</span
        >。您还可以通过“微信登陆”方式登陆，如果您使用“微信登录”，我们还需要获取您在<span
          class="strong"
          >微信平台的OpenID</span
        >。此外当您注册时，我们将通过发送<span class="strong">短信验证码</span
        >的方式验证您的身份，以此识别您在快问健康医生端平台的网络身份，并为您提供快问健康医生端平台服务。如果您拒绝提供手机号码，快问健康医生端平台将无法为您创建账号并提供服务
      </li>
      <p>
        2.1.1 完善个人资料
      </p>
      <li>
        您可以选择向我们提供照片、昵称、姓名、<span class="strong"
          >身份证或其他身份证明（包括但不限于身份证、医保卡、护照的号码和复印件）</span
        >、性别、年龄。您可以在“账户信息”资料中选择是否填写或授权快问健康医生端获取上述信息，以完善您的个人资料。这些“账户信息”将有助于我们为您提供更具个性化的服务。
      </li>
      <p>
        2.1.2 实名认证
      </p>

      <li>
        在您使用医网信账号进行个人签名服务前，您需要向我们提供<span
          class="strong"
          >真实姓名和有效身份证件（包括但不限于身份证、医保卡、护照）的号码和复印件，以便于我们进行实名认证。当您成功登陆时，需要请求您的相机权限，用于刷脸认证的特定业务场景；</span
        >若您不同意或取消授权，可能会影响您对快问健康医生端部分核心业务功能的正常使用，但不会影响您进行基本的浏览、搜索。
      </li>

      <p>
        2.1.3数字证书信息
      </p>
      <li>
        实名认证通过后会由权威CA机构为您颁发数字证书，我们会保留您的数字证书信息，此信息包含<b>您的姓名、身份证件信息，以及为您申请的数字证书序列号，以便供您在处方签名时调用。</b>若您不授权我们保存此信息，您将无法正常使用我们的签名服务。您提供的上述信息，将在您使用我们服务期间持续授权我们使用。
      </li>
      <p>
        2.1.4
        如果您是我们平台的注册医生，您需要提供包括但不仅限于手机号码、邮箱账号、用户名，并创建密码。在注册过程中，如您提供以下额外信息，将有助于我们对您的医疗健康服务资格进行认证：<b>您的真实姓名、性别、身份证正反面照片、联系信息（QQ/微信/邮箱地址）、医院电话、所属科室、擅长科目、《执业医师资格证》、《医师执业证书》、《职称证》、个人证件照（或个人清晰头像）。</b>如果您未提供这些信息，将无法作为快问健康医生端平台注册医生向其他用户提供服务。
      </p>
      <p>2.2为您展示和推送医疗相关信息和服务</p>
      <b
        >为了让您快速地找到您所需要的服务，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息，若您拒绝收集，则无法使用该服务。</b
      >
      <p>
        2.2.1 搜索、浏览功能
      </p>
      <li>
        您可浏览的内容包括快问健康医生端介绍、开方介绍、处方信息、患者信息、工作室设置信息。为了优化给您提供的产品和服务，快问健康医生端有可能收集您的浏览器性质、操作系统种类、给您提供接入服务的ISP域名等，以优化在您手机屏幕上显示的页面；
      </li>
      <p>2.2.2 软件下载、升级服务</p>
      <li>
        为了给您提供软件升级服务，需要收集您PC端、移动端所安装软件的相关信息。
      </li>
      <p>2.2.3 信息发布功能</p>
      <li>
        您注册成为快问健康医生端用户后，可在快问健康医生端平台上向患者进行复诊开方，发布个人公告、分享患教文章。在此过程中，我们可能会收集您的<b
          >设备信息、浏览器类型、日志信息。</b
        >
      </li>
      <p>2.3 向您提供互联网医疗健康服务相关服务或商品</p>
      <p>2.3.1我们在您使用服务过程中收集的信息</p>
      <li>
        为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性、识别账号异常状态，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
      </li>
      <li>
        1）设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息<b>（设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、</b>设备所在位置相关信息<b
          >（
          IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。</b
        >我们会获取用户的软件安装列表（特指移动端安卓设备）用于适配不同厂商的移动设备，保持功能完整且统一。
      </li>
      <li>
        2）日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。如您的<b
          >搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录。</b
        >
      </li>
      <b
        >请您注意，单独的设备信息、浏览器类型或仅搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的单独的设备信息、浏览器类型或搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的设备信息、浏览器类型或搜索关键词信息作为您的个人信息，按照本隐私政策对其进行处理与保护。</b
      >
      <p>2.3.2 我们通过间接获得方式收集到的您的个人信息</p>
      <li>
        我们从第三方获取您授权共享的账户信息<b>（头像、昵称、联系方式），</b>并在您同意声明和隐私后将您的第三方账户与您的账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构等收集与交易进度相关的您的交易、支付，或将您的交易信息共享给上述服务提供者。
      </li>
      <li>
        您可通过同一账号在我们提供的链接入口使用我们关联公司提供的产品或服务，为便于我们基于关联账号共同向您提供一站式服务并便于您统一进行管理，我们在快问健康医生端平台集中展示您的信息或推荐您感兴趣的信息。
        当您通过我们产品或服务使用上述服务时，您授权我们根据实际业务及合作需要从我们关联公司处接收、汇总、分析我们确认其来源合法或您授权同意其向我们提供的您的个人信息或交易信息。
      </li>
      <li>
        如您拒绝提供上述信息或拒绝授权，可能无法使用我们关联公司的相应产品或服务，或者无法展示相关信息，但不影响使用快问健康医生端的咨询问诊等核心服务。
      </li>
      <p>2.4 为您提供安全保障</p>
      <li>
        请注意，为确保账户身份真实性、向您提供更好的安全保障，<b>您可以向我们提供身份证、社保卡等身份信息，绑定支付账户等完成实名认证。</b>如您拒绝提供上述信息，可能无法使用产品功能，继续可能存在风险的操作等，但不会影响您使用浏览服务。
      </li>
      <li>
        为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或快问健康医生端相关协议的情况，<b
          >我们可能使用或整合您的账户信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</b
        >
      </li>
      <p>2.5 其他用途</p>
      <li>
        我们将信息用于本声明和政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
      </li>
      <p>2.6 征得授权同意的例外</p>
      <li>
        根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：
      </li>
      <li>1）与国家安全、国防安全有关的；</li>
      <li>2）与公共安全、公共卫生、重大公共利益有关的；</li>
      <li>3）与犯罪侦查、起诉、审判和判决执行等有关的；</li>
      <li>
        4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      </li>
      <li>5）所收集的个人信息是您自行向社会公众公开的；</li>
      <li>
        6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </li>
      <li>7）根据您的要求签订合同所必需的；</li>
      <li>
        8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
      </li>
      <li>9）为合法的新闻报道所必需的；</li>
      <li>
        10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      </li>
      <li>11）法律法规规定的其他情形。</li>
      <li>
        如我们停止运营快问健康医生端的产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
      </li>
      <p>2.7 设备权限调用</p>
      <li>
        为向您提供便捷、优质的服务，我们可能会调用您设备的一些权限，以下是我们可能调用的设备权限列表及对应的使用目的说明，您有权随时选择关闭下列权限的授权，但可能会影响您正常使用我们产品或服务的部分或全部功能。
      </li>
      <li>1）位置</li>
      <li>
        您需要授权我们使用位置权限，以便于我们基于位置向您展示、推送药店、医院信息。您在首次打开移动客户端时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常使用基于地理位置的信息展示与推送功能。
      </li>
      <li>2）通讯录</li>
      <li>
        在视话问诊时为保护医患双方个人信息安全，我们提供免费中转电话服务。您需要授权我们使用通讯录权限，以便于我们对此电话进行标识。您在使用相应功能时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常在视频电话问诊中使用电话进行沟通。
      </li>
      <li>3）相机</li>
      <li>
        您需要授权我们使用相机权限，以便于使用我们的核心业务功能，如在咨询问诊中发送图片或视频通话。您在使用相应功能时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常在问诊中进行视频通话。
      </li>
      <li>4）通知</li>
      <li>
        您需要授权我们使用通知权限，以便于使用所有基于此权限实现的功能，如支付结果、问诊状态等各类消息提醒。如您关闭后台应用，平台为保证问诊质量和及时性将会在您关闭后台应用后自启动第三方推送功能；您在首次打开移动客户端时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常获取各类消息提醒。
      </li>
      <li>5）无线数据</li>
      <li>
        您需要授权我们使用无线数据权限，以便于我们的移动客户端可以连接网络，向您提供服务。您在首次打开移动客户端时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常使用使用移动客户端。
      </li>
      <li>6）WLAN</li>
      <li>
        您需要授权我们使用WLAN权限，以便于我们的移动客户端可以连接网络，向您提供服务。您在首次打开移动客户端时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常使用使用移动客户端。
      </li>
      <li>7）存储</li>
      <li>
        您需要授权我们使用存储权限，以便于我们的移动客户端可以写入、存储用户信息和日志等。您在首次打开移动客户端时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常使用使用移动客户端。
      </li>
      <li>8）麦克风</li>
      <li>
        您需要授权我们使用麦克风权限，以便于使用我们的核心业务功能，如在咨询问诊中发送语音消息或视频通话。您在使用相应功能时会看到弹窗提醒，询问您是否授权。如您拒绝授权，可能无法正常在问诊中进行视频通话。
      </li>
      <p class="strong">三、我们如何使用Cookie和同类技术</p>
      <li>3.1 Cookie的使用</li>
      <li>
        为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够记住您的选择，提供个性化增强服务等。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问快问健康医生端平台时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
      </li>
      <p>3.2网络Beacon和同类技术的使用</p>
      <li>
        除Cookies外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素"GIF文件或"网络Beacon"）。我们使用网络Beacon的方式有：通过在快问健康医生端平台上使用网络Beacon，计算用户访问数量，并通过访问Cookies辨认注册的快问健康医生端用户及通过得到的Cookies信息，为您提供个性化服务。
      </li>
      <p class="strong">四、我们如何共享、转让、公开披露您的个人信息</p>
      <li>4.1 共享</li>
      <b
        >我们不会与快问健康医生端服务提供者以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</b
      >

      <p>
        4.1.1
        在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
      </p>

      <p>
        4.1.2
        我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
      </p>

      <p>
        4.1.3
        与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护快问健康医生端关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您通过同一账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
      </p>

      <p>
        4.1.4
        与授权合作伙伴共享：仅为实现本声明和隐私中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，当您购买我们的产品时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。<b
          >我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在快问健康医生端中使用该第三方服务。</b
        >
      </p>
      <li>目前，我们的授权合作伙伴包括以下类型：</li>
      <li>
        1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或微信，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。对于广告合作伙伴，我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行匿名化处理，以便它不会识别您；对于分析数据的伙伴，为了更好的分析快问健康医生端用户的使用情况，我们可能向其提供快问健康医生端用户的数量、地区分布、活跃情况等数据，但我们仅会向这些合作伙伴提供不能识别个人身份的统计信息。例如，只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的人口统计信息，帮助他们了解其受众或顾客。
      </li>
      <li>
        2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
      </li>
      <li>
        对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、声明和隐私以及其他任何相关的保密和安全措施来处理个人信息。
      </li>
      <p>4.2 转让</p>
      <li>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </li>
      <li>
        1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
      </li>
      <li>
        2）在快问健康医生端服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受声明和隐私的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      </li>

      <p>4.3 公开披露</p>
      <li>我们不会公开披露您的个人信息，但以下情况除外：</li>
      <li>
        1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
      </li>
      <li>
        2）如果我们确定您出现违反法律法规或严重违反快问健康医生端相关协议规则的情况，或为保护快问健康医生端及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或快问健康医生端相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及快问健康医生端已对您采取的措施。例如，若您严重违反用户协议，我们可能会公开披露或与合作方共享您的身份信息、联系方式与处罚情况。
      </li>
      <li>
        3）基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。
      </li>

      <p>4.4 共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
      <li>
        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
      </li>
      <li>1）与国家安全、国防安全有关的；</li>
      <li>2）与公共安全、公共卫生、重大公共利益有关的；</li>
      <li>3）与犯罪侦查、起诉、审判和判决执行等有关的；</li>
      <li>
        4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </li>
      <li>5）您自行向社会公众公开的个人信息；</li>
      <li>
        6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </li>
      <li>
        根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
      </li>
      <p class="strong">五、用户业务数据和公开信息</p>
      <li>
        不同于您的个人信息，对于用户业务数据和公开信息，快问健康医生端将按如下方式处理：
      </li>
      <li>5.1 用户业务数据</li>
      <li>
        1）您通过快问健康医生端平台提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。快问健康医生端作为服务提供商，我们只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。
      </li>
      <li>
        2）您应对您的用户业务数据来源及内容负责，快问健康医生端提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。
      </li>
      <li>
        3）根据您与快问健康医生端协商一致，快问健康医生端在您选定的数据中心存储用户业务数据。快问健康医生端恪守对用户的安全承诺，根据适用的法律保护用户存储在快问健康医生端数据中心的数据。
      </li>

      <p>5.2 公开信息</p>
      <li>
        1）公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用快问健康医生端服务期间查看或访问这些信息。例如您在医生详情发布的评论信息。
      </li>
      <li>
        2）为使用快问健康医生端的产品或服务，可能存在您必须公开分享的信息。
      </li>
      <li>
        3）在使用快问健康医生端平台进行交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。您也可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。如您发现自己的个人信息泄漏，尤其是您的账户或密码发生泄露，请您立即联络客服，以便快问健康医生端采取相应措施。
      </li>
      <p class="strong">六、我们如何保护您的个人信息</p>
      <li>
        6.1
        我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据（如支付信息）时受https加密保护；我们同时对快问健康医生端相关网站提供https安全浏览方式；我们会使用加密技术和防火墙提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，数据库仅内网访问并尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
      </li>
      <p>
        6.2
        我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
      </p>

      <p>6.3 我们会采取合理可行的措施，尽力避免收集无关的个人信息。</p>

      <p>
        6.4
        互联网并非绝对安全的环境，我们强烈建议您不要使用非快问健康医生端推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
      </p>
      <li>
        在使用快问健康医生端平台进行网上问诊时，您不可避免地要向医务人员或客服披露自己的个人信息，如联系方式或身份信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服，以便我们根据您的申请采取相应措施。
      </li>
      <li>
        请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在医生评论时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您需要删除您的个人信息，您可以联系快问健康医生端客服，我们将帮助您删除您指定的内容。例如，您对医生的评论涉及个人敏感信息，在您需要删除之时，您可以向客服发出通知，我们将会在后台删除您发布的评论。
      </li>
      <li>
        请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
      </li>

      <p>
        6.5
        在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
      </p>

      <p>6.6 我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
      <p class="strong">七、您如何管理您的个人信息</p>
      <li>您可以通过以下方式访问及管理您的个人信息</li>

      <p>7.1 访问您的个人信息</p>
      <li>
        您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：
      </li>
      <li>
        账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息和实名认证信息、更改您的密码或添加绑定微信等，您可以登录账号通过“我的”，“设置”执行此类操作。
      </li>
      <li>银行卡管理：您可以登陆账号，通过“账户”进行银行卡的解绑、绑定。</li>
      <li>
        如果您无法通过上述路径访问该等个人信息，您可以随时通过客服中心与我们取得联系。我们将在15天内回复您的访问请求。
      </li>
      <li>
        对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“7.7响应您的上述请求”中的相关安排向您提供。
      </li>

      <p>7.2 更正或补充您的个人信息</p>
      <li>
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“7.1访问您的个人信息”中列明的方式提出更正或补充申请。
      </li>

      <p>7.3 删除您的个人信息</p>
      <li>您可以通过“7.1访问您的个人信息”中列明的方式删除您的部分个人信息。</li>
      <li>在以下情形中，您可以向我们提出删除个人信息的请求：</li>
      <li>1）如果我们处理个人信息的行为违反法律法规；</li>
      <li>2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</li>
      <li>3）如果我们处理个人信息的行为严重违反了与您的约定；</li>
      <li>4）如果我们永久不再为您提供产品或服务。</li>
      <li>
        若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
      </li>
      <li>
        当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </li>

      <p>7.4 改变您授权同意的范围</p>
      <li>
        您可以通过删除信息、关闭设备功能、在快问健康医生端平台中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。
      </li>
      <li>
        请您理解，每个业务功能需要一些基本的个人信息才能得以完成（见本隐私政策“我们如何收集和使用您的信息”）。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </li>

      <p>7.5 个人信息主体注销账户</p>
      <li>
        在符合快问健康医生端单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项快问健康医生端服务帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定在15个工作日内完成删除或匿名化处理。
      </li>

      <p>7.6 约束信息系统自动决策</p>
      <li>
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害快问健康医生端商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
      </li>

      <p>7.7 响应您的上述请求</p>
      <li>
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </li>
      <li>
        我们将在5-7个工作日内做出答复。如您不满意，还可以通过客服中心发起投诉。
      </li>
      <li>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</li>
      <li>1）与国家安全、国防安全有关的；</li>
      <li>2）与公共安全、公共卫生、重大公共利益有关的；</li>
      <li>3）与犯罪侦查、起诉、审判和执行判决等有关的；</li>
      <li>4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</li>
      <li>5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
      <li>6）涉及商业秘密的。</li>
      <p class="strong">八、您的个人信息的储存</p>
      <li>
        8.1
        我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
      </li>
      <li>1）法律法规有明确规定；</li>
      <li>2）获得您的明确授权；</li>
      <li>3）您通过互联网进行海外就医预约等个人主动行为。</li>
      <li>
        针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护，我们会单独向您以弹窗的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。
      </li>

      <p>8.2 我们承诺您个人信息的存储时间始终处于合理必要期限内。</p>
      <p>
        8.3
        如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除已收集的个人信息。我们会将此情况在网站上进行公告或以站内信等其他合理方式逐一传达到各个用户。
      </p>

      <p class="strong">九、我们如何处理未成年人的个人信息</p>
      <li>
        我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        尽管不同地区对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。
        如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
      </li>

      <p class="strong">十、本声明和政策如何更新</p>
      <li>
        我们可能会不时对本《个人信息保护及隐私政策》进行修订，当本《个人信息保护及隐私政策》发生修订时，我们会在版本更新后以推送通知、弹窗等形式向您展示变更后的内容。请您注意，在《个人信息保护及隐私协议》变更后，我们将无法保证按照其变更前的内容收集、使用、处理和存储您的个人信息。只有在您确认修订后的《个人信息保护及隐私政策》后，我们才会按照修订后的《个人信息保护及隐私政策》收集、使用、处理和存储您的个人信息。因此，如果您不同意修订后的《个人信息保护及隐私政策》，请您停止使用我们的服务。您继续使用我们服务的行为也同样会被视为您同意并接受我们修订后的《个人信息保护及隐私政策》。
      </li>
      <li>
        未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
      </li>
      <li>
        对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，
        我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。
      </li>
      <li>本政策所指的重大变更包括：</li>
      <li>
        a、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      </li>
      <li>
        b、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
      </li>
      <li>c、个人信息共享、转让或公开披露的主要对象发生变化；</li>
      <li>d、您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
      <li>
        e、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      </li>
      <li>f、个人信息安全影响评估报告表明存在高风险时。</li>

      <p class="strong">十一、如何联系我们</p>
      <li>
        以下情况，您可以通过在线客服与我们联系，一般情况下我们将在15天内回复您的请求：
      </li>
      <li>
        （1）如对本声明和隐私内容有任何疑问、意见或建议；客服电话：400-020-1199
      </li>
      <li>（2）如发现个人信息可能被泄露；</li>
      <li>
        （3）关于你的个人信息，你可以通过以下方式与开发者联系，行使查阅、复制、更正、删除等法定权利。
        快问中医互联网医院小程序: 点击【我的】页面-点击头像可更正、注销个人信息
      </li>
      <p class="strong">十二、其他</p>
      <li>使用SDK名称：友盟SDK；</li>
      <li>服务类型：统计分析，微信分享</li>
      <li>收集个人信息类型：</li>
      <li>
        设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等）
        友盟隐私权政策：https://www.umeng.com/page/policy
      </li>
      <li>使用SDK名称：极光推送SDK；</li>
      <li>服务类型：消息推送</li>
      <li>收集个人信息类型：</li>
      <li>
        设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等）
        设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）
      </li>
      <li>极光推送隐私政策：https://www.jiguang.cn/license/privacy</li>
      <li>使用SDK名称：支付宝SDK；</li>
      <li>服务类型：支付宝账号绑定授权</li>
      <li>收集个人信息类型：支付宝用户授权AutoCode</li>
      <li>支付宝隐私政策：https://opendocs.alipay.com/open/01g6qm</li>
      <li>使用SDK名称：腾讯Bugly SDK；</li>
      <li>服务类型：应用线上异常情况收集</li>
      <li>应用信息（应用崩溃信息）</li>
      <li>设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）</li>
      <li>
        Bugly隐私声明：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf
      </li>
      <li>使用SDK名称：阿里 SDK；</li>
      <li>服务类型：刷脸认证登陆</li>
      <li>收集个人信息类型：姓名、身份证</li>
      <li>隐私声明：https://help.aliyun.com/document_detail/286447.html</li>

      <li>使用SDK名称：腾讯云移动推送 SDK；</li>
      <li>服务类型：在移动终端设备进行消息推送</li>
      <li>收集个人信息类型：</li>
      <li>
        设备信息(手机型号，系统类型、系统版本等)用于标签化推送以及识别是否是真机、网络信息(网络类型)支持根据不同网络类型进行不同类型推送、账号绑定信息(根据您所选用的不同推送渠道，QQ号、微信UnionID、手机号、邮箱等)用于根据账号信息进行推送，应用数据（推送流程中产生的送达、点击、曝光等数据）用于推送业务数据统计。
      </li>
      <li>数据处理方式：通过去标识化、加密传输及其他安全方式。</li>
      <li>
        隐私政策链接：https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727
      </li>
      <li>使用SDK名称：OPPO PUSH SDK；</li>
      <li>服务类型：</li>
      <li>
        提供推送服务，包括推送消息、记录消息发送结果返回给开发者，提供折叠不重要通知等功能;
      </li>
      <li>收集个人信息类型：</li>
      <li>
        消息内容、设备相关信息（例如 IMEI 或 OAID，Serial
        Number，IMSI，UserID，Android ID，Google Advertising ID, 手机
        Region设置，设备型号，手机电量、手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为）、锁屏状态（如是否锁屏，是否允许锁屏通知）、广告主或开发者的指示收集终端用户的设备识别码（IMEI
        或 OAID）、IP 地址、客户端系统、客户端网络类型、客户端时间（部分场景）。
      </li>
      <li>隐私政策链接：https://open.oppomobile.com/wiki/doc#id=10288</li>
      <li>使用SDK名称：小米推送 SDK；</li>
      <li>服务类型：提供推送服务</li>
      <li>收集个人信息类型：</li>
      <li>
        设备标识(OAID 和加密的
        AndroidID)，以及使用推送服务的应用信息如应用包名、版本号和运行状态。
      </li>
      <li>
        消息创建、送达和点击时间并暂存从第三方应用处获得并推送给您的消息内容。
      </li>
      <li>
        设备相关信息如设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型。其中当前网络类型、SIM卡运营商名称仅在设备本地读取，不会上传至小米服务器。
      </li>
      <li>通知栏设置信息，包括是否屏蔽通知栏、是否设置锁屏弹出消息等。</li>
      <li>隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822</li>
      <li>使用SDK名称：阿里云SDK；</li>
      <li>
        服务类型：帮助您实现快捷视频、音频、图片、字母等各种媒体文件到点播存储的服务
      </li>
      <li>收集个人信息类型：UUID、设备型号、IP地址</li>
      <li>隐私政策链接：</li>
      <li>
        https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html
      </li>
    </div>
    <div v-if="show_cancel" class="rule-buttom">
      <div class="rule-buttom-cancel" @click="cancelAuth">取消授权</div>
    </div>
  </div>
</template>

<script>
import { getPlatforms } from '~/utils'
export default {
  head() {
    return { title: '快问健康医生端隐私政策' }
  },
  data() {
    return {
      show_cancel: false,
      isIOSPlatforms: getPlatforms().isiOS
    }
  },
  mounted() {
    this.$route.query.show_cancel && (this.show_cancel = true)
  },
  methods: {
    cancelAuth() {
      this.$bridge.cancelAuth()
    }
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  color: #6d6d72;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
}

li {
  list-style: none;
}

p,
li {
  line-height: 23px;
}

body > div,
body > h3,
body > h4 {
  padding: 0 4.266vmin;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

h3 {
  font-size: 17px;
  margin: 4vmin;
  color: #000000;
}

.page {
  padding: 6.66vmin 16px;
  padding-bottom: 65px;
  word-break: break-word;
}

div {
  line-height: 5.33vmin;
  font-size: 14px;
  color: #333;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin-top: 16px;
  border: 2px solid #666666;
}

td {
  border: none;
  border-right: 1px solid #666666;
  border-bottom: 1px solid #666666;
  word-wrap: break-word;
  word-break: break-all;
}

tr {
  border: none;
}

p,
.marginT15 {
  margin-top: 15px;
}

b {
  color: #000000;
}

.strong {
  color: #000000;
  font-weight: bold;
}
.youmeng {
  margin-top: 20px;
}
.content-block {
  margin: 32px 0 65px 0;
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 23px;
  color: #6d6d72;
}
.youmeng a {
  color: #6d6d72;
}
.rule-buttom {
  width: 100%;
  height: 60px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-content: center;
  position: fixed;
  bottom: 0;
}
.rule-buttom-cancel {
  width: 347px;
  height: 44px;
  background: #e3e3e4;
  border-radius: 5px;
  font-size: 16px;
  color: rgba(102, 102, 102, 0.95);
  line-height: 44px;
  text-align: center;
}
</style>
